import Vue from 'vue'
import App from './App.vue'

import router from './route'
import './registerServiceWorker'
import store from './store'
import VeeValidate from 'vee-validate'
import axios from 'axios'

import AsyncComputed from 'vue-async-computed'

import PortalVue from 'portal-vue'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import { addRefreshTokenFlow } from './refresh-token'
import { jsPDF } from "jspdf";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//dotenv.config()

//import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
import VueLazyLoad from 'vue-lazyload'

import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

//storage constants
import storage_constants from './exports/constants'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(Chartkick.use(Chart))

Vue.config.productionTip = false

Vue.use(jsPDF)
Vue.use(VueLazyLoad)

Vue.use(PortalVue)

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

Vue.use(VeeValidate, {
    events: 'blur',
    inject: true,
    fieldsBagName: 'veeFields',
})

//async computed
Vue.use(AsyncComputed)

console.log('storage constants:', storage_constants)
//global variables
Vue.prototype.$OMSStorageUrl = storage_constants.STORAGE_URL // process.env.VUE_APP_STORAGE_URL
Vue.prototype.$OMSServersUrl = storage_constants.SERVERS_URL // process.env.VUE_APP_SERVERS_URL
Vue.prototype.$OMSOldStorageUrl = storage_constants.OLD_STORAGE_URL // process.env.VUE_APP_OLD_STORAGE_URL
Vue.prototype.$DefaultApiServer = 'http://localhost:8000' // process.env.VUE_APP_API_SERVER
Vue.prototype.$userPermissions = {}

router.beforeEach((to, from, next) => {
    const link = to.fullPath

    if (link !== '/admin/transfer-section-items/') {
        localStorage.setItem('storedData', null)
    }

    next()
})

store.dispatch('getBaseURL').then(() => {
    Vue.nextTick(() => {
        axios.defaults.baseURL = store.state.baseURL
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
        //get token
        store.dispatch('getToken')

        console.log('baseURL', store.state.baseURL)

        addRefreshTokenFlow(axios)
        new Vue({
            router,
            store,
            render: h => h(App),
        }).$mount('#app')
    })
})
